import { createSelector } from 'reselect';
import { selectAllAbsencesFlat } from 'modules/SalaryModule/Calendar/selectors';

export const selectVacationModalData = (state) =>
  state.vacationsReducer?.vacationModalData;

export const selectVacationModalSubmitType = (state) =>
  state.vacationsReducer?.submitType;

export const selectVacationModalLeaveObject = createSelector(
  [(state) => state.vacationsReducer?.leaveObjId, selectAllAbsencesFlat],
  (leaveObjId, absences) => absences.find(({ id }) => id === leaveObjId) || null
);

export const selectVacationModalVisibility = (state) =>
  state.vacationsReducer?.isModalVisible;

export const selectVacationModalStartDate = (state) =>
  state.vacationsReducer?.startDate;

export const selectAbsencesRequestStatus = (state) =>
  state.vacationsReducer?.status;

export const selectEmployeeAbsences = (state) =>
  state.vacationsReducer?.employeeAbsences || [];

export const selectTableDefaultPage = (state) =>
  state.vacationsReducer?.tableDefaultPage;
